export default __webpack_public_path__ + "static/media/logo-public.f99ace62.png";